import { StyleSheet, Dimensions } from 'react-native';
const ls = StyleSheet.create({
  container: {
    marginHorizontal: 16,
    marginTop: 24,
  },
  shadow: {
    shadowColor: '#98A2B3',
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.2,
    shadowRadius: 4.65,
  },
  coinImage: {
    height: 87,
    width: 70,
  },
  coinImageContainer: {
    marginTop: -10,
  },
  subHeading: {
    display: 'flex',
    backgroundColor: '#FFFFFF',
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    borderWidth: 1,
    borderTopWidth: 0,
    borderColor: '#E4E7EC',
    flex: 1,
  },
  subHeadingWithPadding: {
    display: 'flex',
    backgroundColor: '#FFFFFF',
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    borderWidth: 1,
    borderTopWidth: 0,
    borderColor: '#E4E7EC',
    flex: 1,
    paddingBottom: 24,
  },
  buttonElevation: {
    elevation: 24,
    paddingTop: 16,
    paddingHorizontal: 12,
    marginHorizontal: Dimensions.get('screen').width > 450 ? 16 : 0,
  },
  signImg: {
    height: 12,
    width: 13,
  },
  signImageContainer: {
    paddingBottom: 23,
    marginTop: 11,
  },
  text: {
    marginBottom: 4,
  },
  iconContainer: {
    paddingVertical: 12,
    justifyContent: 'center',
  },
  eligibleText: {
    paddingVertical: 12,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 8,
  },
});

export default ls;
